/* eslint-disable import/prefer-default-export */
import { MentorshipProgramConnection } from 'redux/schemas/models/mentorship-program-connections';

export const getConnectionName = (connection: MentorshipProgramConnection, enrollmentId: number) => {
  const { mentorshipProgramConnectionMembers } = connection || {};
  const connectionEnrollment = mentorshipProgramConnectionMembers?.find(
    (member) => member.mentorshipProgramEnrollment.id !== enrollmentId,
  )?.mentorshipProgramEnrollment;
  const { user } = connectionEnrollment || {};
  const { firstName: connectionName } = user || {};
  return connectionName;
};
